<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<cbs-context-menu
		v-if="
			todoItem.can_update ||
				mixinIsCanCreateRequest ||
				(todoItem.can_cancel && todoItem.type === $constant.TODO_TYPE.NORMAL) ||
				(todoItem.readableProperties && todoItem.readableProperties.is_cancel && mixinIsCanCreateTodo)
		"
		v-bind="$attrs"
		:class="['todo-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'todo-context-menu-list' }"
	>
		<!-- Tạo lại -->
		<div
			v-if="todoItem.readableProperties && todoItem.readableProperties.is_cancel && mixinIsCanCreateTodo"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickRecreate', todoItem.id)"
		>
			<i class="nucleo mr-3 nucleo-single-copy-04" />
			{{ $t("Actions.Recreate") }}
		</div>
		<!-- Confirm todo complete -->
		<div
			v-if="displayMode === 'list'"
			v-for="(status, idx) in todoItem.changable_statuses"
			:key="`status${idx}`"
			:divider="idx === todoItem.changable_statuses.length - 1"
			class="request-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit(statusEmits(status.key), todoItem.id, status.key)"
		>
			<i
				:class="[
					'nucleo mr-3 text-solid-green-1',
					{
						'nucleo-c-check':
							JSON.parse(status.key) === $constant.TODO_ITEM_STATUSES.STATUS_DOING ||
							JSON.parse(status.key) === $constant.TODO_ITEM_STATUSES.STATUS_CLOSED ||
							JSON.parse(status.key) === $constant.TODO_ITEM_STATUSES.STATUS_DONE,
						'nucleo-c-remove-2 text-solid-red': JSON.parse(status.key) === $constant.TODO_ITEM_STATUSES.STATUS_REJECTED
					}
				]"
			/>
			{{ status.value }}
		</div>
		<div v-if="todoItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', todoItem.id)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>
		<!-- Add Detail -->
		<div v-if="todoItem.can_add_detail" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickAddDetail', todoItem)">
			<i :class="['nucleo-add-checklist', 'nucleo mr-3']" />
			{{ $t("AddDetail") }}
		</div>
		<!-- Time repeater -->
		<div v-if="todoItem.from_type_id > 0" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickSettingTimeRepeater', todoItem.from_type_id)">
			<i :class="['nucleo-repeat', 'nucleo mr-3']" />
			{{ $t("SettingTimeRepeater") }}
		</div>
		<div v-if="todoItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickReminder', todoItem.id)">
			<i class="nucleo mr-3 nucleo-reminder-outline" />
			{{ $t("Actions.SettingReminder") }}
		</div>
		<div v-if="todoItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickWatcher', todoItem.id)">
			<i :class="['nucleo-b-add-outline', 'nucleo mr-3']" />
			{{ $t("AddWatcher") }}
		</div>
		<div v-if="mixinIsCanCreateRequest" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCreateRequest', todoItem.id)">
			<i class="nucleo mr-3 nucleo-cm-addrequest" />
			{{ $t("CreateRequest") }}
		</div>
		<div v-if="mixinIsCanCreateTodo" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCreateClone', todoItem.id)">
			<i class="nucleo mr-3 nucleo-duplicate-outline" />
			{{ $t("CreateClone") }}
		</div>

		<div v-if="todoItem.can_cancel" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCancel', todoItem.id)">
			<i class="nucleo mr-3 nucleo-filter-remove" />
			{{ $t("Actions.Cancel") }}
		</div>

		<!-- Schedule Todo -->
		<div
			v-if="todoItem.can_update && todoItem.type === $constant.TODO_TYPE.SCHEDULE"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickToggleScheduleTodo', { id: todoItem.id, enable: !todoItem.readableProperties.schedule_enable })"
		>
			<i :class="[todoItem.readableProperties.schedule_enable ? 'nucleo-calendar-date' : 'nucleo-calendar-event', 'nucleo mr-3']" />
			{{ todoItem.readableProperties.schedule_enable ? $t("DisableSchedule") : $t("EnableSchedule") }}
		</div>
	</cbs-context-menu>
	<span v-else></span>
</template>

<script>
import { todoPermissions, requestPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "TodoItemContextMenu",
	mixins: [getUserPermissions({ ...todoPermissions, ...requestPermissions })],
	components: { CbsContextMenu },
	props: {
		todoItem: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickCancel: {},
		onClickRecreate: {},
		onClickCreateRequest: {}
	},
	data() {
		return {
			statusActions: {
				0: "",
				1: "onCompleteTodo",
				2: "onClickCancel",
				4: "onSetStatusTodo",
				5: "onSetStatusTodo",
				7: "onClickReject"
			}
		};
	},
	methods: {
		statusEmits(key) {
			return this.statusActions[key];
		}
	}
};
</script>

<style lang="scss" scoped>
.todo-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.todo-context-menu-list {
	.todo-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
